<template>
  <b-container>
    <div>
      <div class="mb-5 d-flex">
        <Breadcrumbs />
        <router-link :to="currentRouteLink" class="not-active ml-2">
          {{ currentRouteLabel }}</router-link
        >
      </div>
      <ProjectHeroBanner
        :image="require('@/assets/dataset/images/health-project.png')"
        heading="Nigeria’s Health Project Inventory"
        button-one-link="/inventory/project-inventory"
        button-two-link="/inventory/submit-project"
        button-one-text="Explore Projects"
        button-two-text="Submit Projects"
      />
      <div class="mt-5 content">
        <p class="text-center font-weight-bold h5">About Health Project Inventory</p>
        <p class="text-left pt-3">
          The Department of Health Planning, Research and Statistics (DPRS) of the Federal Ministry
          of Health has developed this web based inventory containing information of previous and
          ongoing health related data collection activities carried out in the country over the last
          ten years. This will help create clear data flow channels between stakeholders in the
          health sector, avoid wastage of resources by enhancing coordination between stakeholders,
          and reduce duplication in data collection.
        </p>
        <div class="text-left">
          <b-link v-if="!seemore" class="text-left text-decoration-none" @click="seemore = true">
            <i class="fas fa-chevron-down text-primary mr-1" />
            See more
          </b-link>
          <b-link v-else class="text-left text-decoration-none" @click="seemore = false">
            <i class="fas fa-chevron-up text-primary mr-1" />
            See less
          </b-link>
        </div>
        <div v-if="seemore">
          <p class="text-center font-weight-bold h5 mt-5">Introduction</p>
          <p class="text-left pt-3">
            Multiple partners (multiple and bilateral donors, non-governmental organizations, faith
            based organizations and the private sector) carry out multiple vertical health
            intervention programs in the country with the overall goal of improving the health and
            well-being of Nigerians. To build an effective monitoring system to coordinate health
            partners, there is a need to document their activities and objectives.
            <br />
            <br />
            In response to this need, this web based health partners’ inventory has been developed
            by the Department of Health Planning, Research and Statistics (DPRS) to update our data
            on all health interventions carried out in the country from 2015. This will help provide
            insight into the current situation of health partners and their projects in the country,
            and ensure that funds provided to carry out health projects are not targeted at a few
            disease programs or a narrow set of interventions.
          </p>
          <p class="text-center font-weight-bold h5 mt-5">Objectives</p>
          <p class="text-left pt-3">
            The objectives of this web based health partners’ inventory are:
          </p>
          <ol class="ml-n4">
            <li class="text-left">
              To have an accessible online database of all health partners in the country
            </li>
            <li class="text-left">
              To have a holistic view of health projects carried out by health partners within the
              country.
            </li>
            <li class="text-left">
              To identify gaps in health programs and interventions, and reschedule priorities for
              future planning.
            </li>
            <li class="text-left">
              To enhance harmonization and information sharing among health partners for a more
              coordinated, coherent and efficient health partner support system.
            </li>
            <li class="text-left">
              To monitor health partners and ensure the alignment of their activities with the
              country’s agenda and priorities.
            </li>
          </ol>
        </div>
        <!-- working on the spinner overlay -->
        <div class="spin-overlay" v-show="populating" style="background-color: transparent">
          <div>Please wait</div>
          <b-spinner
            variant="success"
            label="Spinning"
            class="spinner"
            style="width: 8rem; height: 8rem"
          ></b-spinner>
        </div>
        <p class="text-center font-weight-bold h5 mt-5">Health Projects In Nigeria</p>
        <b-row class="p-0 mt-4" no-gutters align-h="between">
          <b-col cols="12" sm="9">
            <div class="map">
              <!-- <Map :map-object="options" :level="level" :lga-state="'Lagos'" :chartData="chartData" /> -->
              <mapChart :chartData="chartData"></mapChart>
            </div>
          </b-col>
          <b-col cols="3" class="pl-5 d-none d-sm-block">
            <FilterSideBar :showsideborder="false" :access-level="false" />
          </b-col>
        </b-row>
      </div>
    </div>
  </b-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
// import Map from '@/components/maps/BaseMap.vue';
import mapChart from '@/components/maps/NigeriaMap.vue';
import nigerianMap from '../../components/nigeria';
import ProjectHeroBanner from '../../components/Layout/ProjectHeroBanner.vue';
import FilterSideBar from '../../components/Shared/FilterSideBar.vue';
import Breadcrumbs from '../../components/Shared/Breadcrumbs.vue';
// import mapdata from '../../components/map';

export default {
  name: 'ProjectInventoryMap',
  components: {
    ProjectHeroBanner,
    FilterSideBar,
    // Map,
    mapChart,
    Breadcrumbs,
  },
  data() {
    return {
      level: 1,
      currentRouteLabel: '',
      currentRouteLink: '',
      breadcrumb: {
        breadcrumbLink: '',
        breadcrumbLabel: '',
      },
      mapObject: {
        series: [
          {
            animation: {
              duration: 700,
            },
            allAreas: false,
            data: [],
            name: 'Number of Project',
            states: {
              hover: {
                color: '#e8f5eb',
              },
            },
            dataLabels: {
              enabled: true,
              format: '{point.name}',
            },
          },
        ],
      },
      options: {
        chart: {
          map: nigerianMap,
          height: `${(9 / 13) * 100}%`,
          backgroundColor: '#e8f5eb77',
        },
        mapNavigation: {
          enabled: true,
          buttonOptions: {
            verticalAlign: 'top',
          },
        },
        colorAxis: {
          min: 0,
        },
        title: {
          text: '',
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },
        series: [
          {
            data: [
              ['ng-ri', 13],
              ['ng-kt', null],
              ['ng-so', null],
              ['ng-za', null],
              ['ng-yo', 4],
              ['ng-ke', 5],
              ['ng-ad', 6],
              ['ng-bo', 7],
              ['ng-ak', null],
              ['ng-ab', 9],
              ['ng-im', null],
              ['ng-by', null],
              ['ng-be', null],
              ['ng-cr', 13],
              ['ng-ta', 14],
              ['ng-kw', 0],
              ['ng-la', 16],
              ['ng-ni', 17],
              ['ng-fc', 18],
              ['ng-og', 19],
              ['ng-on', 20],
              ['ng-ek', 21],
              ['ng-os', 22],
              ['ng-oy', 23],
              ['ng-an', 24],
              ['ng-ba', 25],
              ['ng-go', 26],
              ['ng-de', 27],
              ['ng-ed', 28],
              ['ng-en', 29],
              ['ng-eb', 30],
              ['ng-kd', 31],
              ['ng-ko', 32],
              ['ng-pl', 33],
              ['ng-na', 0],
              ['ng-ji', 35],
              ['ng-kn', 36],
            ],
            name: 'Number of Project',
            states: {
              hover: {
                color: '',
              },
            },
            dataLabels: {
              enabled: true,
              format: '{point.name}',
            },
          },
        ],
      },
      seemore: false,
      sections: [
        {
          title: 'Research Knowledge and Management',
          description:
            'Coordinate and promote all health research for efficient health system development and knowledge sharing',
          link: '/inventory/stakeholder',
        },
        {
          title: 'Policy and Planning',
          description:
            'Coordinate health policy and plan formulation, review and priority settings',
          link: '/',
        },
        {
          title: 'International Cooperation',
          description:
            'Coordinate international cooperation on health and collaborations with development partners, NGOs and other health actor',
          link: '/',
        },
        {
          title: 'Monitoring and Evaluation Division',
          description:
            'Coordinate monitoring and evaluation of the health system and its performance',
          link: '/',
        },
        {
          title: 'Health System Strengthening',
          description: 'Plan for human resource for health development',
          link: '/',
        },
      ],
      populating: true,
    };
  },
  computed: {
    ...mapGetters('DATASET_STORE', ['getStateGeoCoverage', 'getFilterData']),
    ...mapState('DATASET_STORE', ['breadCrumbData']),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      let previousRouteLabel = '';
      let previousRouteLink = '';

      if (from.path === '/inventory/project') {
        previousRouteLabel = 'Project Inventory';
        previousRouteLink = from.path;
      }
      if (from.path === '/') {
        previousRouteLabel = 'Home';
        previousRouteLink = from.path;
      }
      if (from.path === '/inventory/project-inventory') {
        previousRouteLabel = 'Explore Projects';
        previousRouteLink = from.path;
      }
      if (from.path === '/inventory/submit-project') {
        previousRouteLabel = 'Submit Project';
        previousRouteLink = from.path;
      }
      if (from.path === '/inventory/dataset') {
        previousRouteLabel = 'Dataset Inventory';
        previousRouteLink = from.path;
      }
      if (from.path === '/inventory/dataset-inventory') {
        previousRouteLabel = 'Explore Datasets';
        previousRouteLink = from.path;
      }
      if (from.path === '/inventory/submit-dataset') {
        previousRouteLabel = 'Submit Datasets';
        previousRouteLink = from.path;
      }

      // Set the component data properties
      vm.breadcrumb.breadcrumbLabel = previousRouteLabel;
      vm.breadcrumb.breadcrumbLink = previousRouteLink;

      if (vm.breadCrumbData) {
        let itemExists = false;

        vm.breadCrumbData.forEach((item) => {
          if (item.breadcrumbLabel === vm.breadcrumb.breadcrumbLabel) {
            itemExists = true;
          }
        });

        if (!itemExists) {
          vm.PUSHBREADCRUMB(vm.breadcrumb);
        }
      }

      next();
    });
  },

  methods: {
    ...mapActions('DATASET_STORE', ['SETPOPULATING', 'PUSHBREADCRUMB']),
    getRoute() {
      if (this.$route.path === '/inventory/project') {
        this.currentRouteLink = this.$route.path;
        this.currentRouteLabel = 'Project Inventory';
      }
      if (this.$route.path === '/') {
        this.currentRouteLink = this.$route.path;
        this.currentRouteLabel = 'Home';
      }
      if (this.$route.path === '/inventory/project-inventory') {
        this.currentRouteLink = this.$route.path;
        this.currentRouteLabel = 'Explore Projects';
      }
      if (this.$route.path === '/inventory/submit-project') {
        this.currentRouteLink = this.$route.path;
        this.currentRouteLabel = 'Submit Project';
      }
      if (this.$route.path === '/inventory/dataset') {
        this.currentRouteLink = this.$route.path;
        this.currentRouteLabel = 'Dataset Inventory';
      }
      if (this.$route.path === '/inventory/dataset-inventory') {
        this.currentRouteLink = this.$route.path;
        this.currentRouteLabel = 'Explore Datasets';
      }
      if (this.$route.path === '/inventory/submit-dataset') {
        this.currentRouteLink = this.$route.path;
        this.currentRouteLabel = 'Submit Datasets';
      }
    },
  },

  watch: {
    // whenever question changes, this function will run
    getFilterData(val) {
      this.populating = true;

      // refactoring
      const states = [
        'Abia',
        'Adamawa',
        'Anambra',
        'Bauchi',
        'Bayelsa',
        'Benue',
        'Borno',
        'Delta',
        'Ebonyi',
        'Edo',
        'Ekiti',
        'Enugu',
        'Gombe',
        'Imo',
        'Jigawa',
        'Kaduna',
        'Kano',
        'Katsina',
        'Kebbi',
        'Kogi',
        'Kwara',
        'Lagos',
        'Nasarawa',
        'Niger',
        'Ogun',
        'Ondo',
        'Osun',
        'Oyo',
        'Plateau',
        'Rivers',
        'Sokoto',
        'Taraba',
        'Yobe',
        'Zamfara',
        'FCT',
      ];
      states.forEach((state) => {
        const filter = this.geoCoverage.data.results.filter((geo) => geo.name === state);
        //  this.projectsNum[state]
        this.stateProjs = this.projects.data.results.filter((proj) =>
          proj.geocoverages.includes(filter[0].id)
        );

        console.log('state projects', this.stateProjs);

        // status
        val.status.forEach((sta) => {
          console.log('status', sta);
          this.stateProjs = this.stateProjs.filter((proj) => proj.status.value === sta);
        });

        // program areas
        val.program_areas.forEach((pro) => {
          this.stateProjs = this.stateProjs.filter((proj) => proj.program_areas.includes(pro));
        });

        this.projectsNum[state] = this.stateProjs.length;
      });

      this.chartData = [
        ['ng-ri', this.projectsNum.Rivers],
        ['ng-kt', this.projectsNum.Kastina],
        ['ng-so', this.projectsNum.Sokoto],
        ['ng-za', this.projectsNum.Zamfara],
        ['ng-yo', this.projectsNum.Yobe],
        ['ng-ke', this.projectsNum.Kebbi],
        ['ng-ad', this.projectsNum.Adamawa],
        ['ng-bo', this.projectsNum.Borno],
        ['ng-ak', this.projectsNum.AkwaIbom],
        ['ng-ab', this.projectsNum.Abia],
        ['ng-im', this.projectsNum.Imo],
        ['ng-by', this.projectsNum.Bayelsa],
        ['ng-be', this.projectsNum.Benue],
        // ['ng-cr', this.ProjectsNum.Cross],
        ['ng-ta', this.projectsNum.Taraba],
        ['ng-kw', this.projectsNum.Kwara],
        ['ng-la', this.projectsNum.Lagos],
        ['ng-ni', this.projectsNum.Niger],
        ['ng-fc', this.projectsNum.FCT],
        ['ng-og', this.projectsNum.Ogun],
        ['ng-on', this.projectsNum.Ondo],
        ['ng-ek', this.projectsNum.Ekiti],
        ['ng-os', this.projectsNum.Osun],
        ['ng-oy', this.projectsNum.Oyo],
        ['ng-an', this.projectsNum.Anambra],
        ['ng-ba', this.projectsNum.Anambra],
        ['ng-go', this.projectsNum.Gombe],
        ['ng-de', this.projectsNum.Delta],
        ['ng-ed', this.projectsNum.Edo],
        ['ng-en', this.projectsNum.Enugu],
        ['ng-eb', this.projectsNum.Ebonyi],
        ['ng-kd', this.projectsNum.Kaduna],
        ['ng-ko', this.projectsNum.Kogi],
        ['ng-pl', this.projectsNum.Plateau],
        ['ng-na', this.projectsNum.Nasarawa],
        ['ng-ji', this.projectsNum.Jigawa],
        ['ng-kn', this.projectsNum.Kano],
      ];

      this.populating = false;
      this.SETPOPULATING(false);
    },
  },

  async mounted() {
    this.getRoute();
    this.geoCoverage = await this.$dataset.getAllGeoCoverage();
    this.projects = await this.$dataset.getAllProjects();

    // refactoring
    const states = [
      'Abia',
      'Adamawa',
      'Anambra',
      'Bauchi',
      'Bayelsa',
      'Benue',
      'Borno',
      'Delta',
      'Ebonyi',
      'Edo',
      'Ekiti',
      'Enugu',
      'Gombe',
      'Imo',
      'Jigawa',
      'Kaduna',
      'Kano',
      'Katsina',
      'Kebbi',
      'Kogi',
      'Kwara',
      'Lagos',
      'Nasarawa',
      'Niger',
      'Ogun',
      'Ondo',
      'Osun',
      'Oyo',
      'Plateau',
      'Rivers',
      'Sokoto',
      'Taraba',
      'Yobe',
      'Zamfara',
      'FCT',
    ];
    states.forEach((state) => {
      const filter = this.geoCoverage.data.results.filter((geo) => geo.name === state);
      //  this.projectsNum[state]
      this.stateProjs = this.projects.data.results.filter((proj) =>
        proj.geocoverages.includes(filter[0].id)
      );
      this.projectsNum[state] = this.stateProjs.length;
    });

    // eslint-disable-next-line no-unused-expressions
    (this.chartData = [
      ['ng-ri', this.projectsNum.Rivers],
      ['ng-kt', this.projectsNum.Kastina],
      ['ng-so', this.projectsNum.Sokoto],
      ['ng-za', this.projectsNum.Zamfara],
      ['ng-yo', this.projectsNum.Yobe],
      ['ng-ke', this.projectsNum.Kebbi],
      ['ng-ad', this.projectsNum.Adamawa],
      ['ng-bo', this.projectsNum.Borno],
      ['ng-ak', this.projectsNum.AkwaIbom],
      ['ng-ab', this.projectsNum.Abia],
      ['ng-im', this.projectsNum.Imo],
      ['ng-by', this.projectsNum.Bayelsa],
      ['ng-be', this.projectsNum.Benue],
      // ['ng-cr', this.ProjectsNum.Cross],
      ['ng-ta', this.projectsNum.Taraba],
      ['ng-kw', this.projectsNum.Kwara],
      ['ng-la', this.projectsNum.Lagos],
      ['ng-ni', this.projectsNum.Niger],
      ['ng-fc', this.projectsNum.FCT],
      ['ng-og', this.projectsNum.Ogun],
      ['ng-on', this.projectsNum.Ondo],
      ['ng-ek', this.projectsNum.Ekiti],
      ['ng-os', this.projectsNum.Osun],
      ['ng-oy', this.projectsNum.Oyo],
      ['ng-an', this.projectsNum.Anambra],
      ['ng-ba', this.projectsNum.Anambra],
      ['ng-go', this.projectsNum.Gombe],
      ['ng-de', this.projectsNum.Delta],
      ['ng-ed', this.projectsNum.Edo],
      ['ng-en', this.projectsNum.Enugu],
      ['ng-eb', this.projectsNum.Ebonyi],
      ['ng-kd', this.projectsNum.Kaduna],
      ['ng-ko', this.projectsNum.Kogi],
      ['ng-pl', this.projectsNum.Plateau],
      ['ng-na', this.projectsNum.Nasarawa],
      ['ng-ji', this.projectsNum.Jigawa],
      ['ng-kn', this.projectsNum.Kano],
      // eslint-disable-next-line no-sequences
    ]),
      (this.populating = false);
  },
};
</script>

<style lang="scss" scoped>
ul.dash {
  list-style: none;
  margin-left: 0;
  padding-left: 1em;
}
ul.dash > li:before {
  display: inline-block;
  content: '-';
  width: 1em;
  margin-left: -1em;
}

.map {
  background-color: #ecf5ef;
  border: 1px solid #707070;
  padding: 3rem;
}

// moses added
.spin-overlay {
  z-index: 3;
  position: absolute;
  width: 60vw;
  height: 100vh;
  background-color: rgb(19, 26, 26);
  opacity: 0.5;
}

.spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  margin-top: 300px;
}
.text-left {
  text-align: justify !important;
}
@media screen and (max-width: 600px) {
  .content {
    margin-top: 7rem !important;
  }
}
</style>
